import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../../../components/PageHeader";
import RecursiveListComponent from "../../../../components/recursivelist/RecursiveListComponent";
import {RecursiveList} from "../../../../components/recursivelist/RecursiveList";
import {RecursiveInfo} from "../../../../components/recursivelist/RecursiveInfo";
import {deleteCustomCode, getCustomCodeList, updateCustomCode} from "../../../../api/field/CustomCodeService";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {CacheType, CodeSpecNum} from "../../../../constant/CodeSpecNum";
import {callAsyncHandler} from "../../../../components/commonmethod/CommonMethod";
import {refresh} from "../../../../redux/slice/apiSlice";
import {useDispatch, useSelector} from "react-redux";
import {useCacheRefresh} from "../../../../hooks/useCacheRefresh";
import CodeCreateInput from "../../../../components/recursivelist/CodeCreateInput";
import {createCode, selectCodesByParentId} from "../../../../api/code/CodeService";

function ClaimCode() {

    const [code, setCode] = useState(null);
    const [data, setData] = useState(null);
    const status = useSelector(state => state.api.status);
    const dispatch = useDispatch();
    const refreshCache = useCacheRefresh();

    useEffect(() => {
        getList();
        dispatch(refresh(false));
    }, [status])

    async function getList() {
        const data = await selectCodesByParentId(CodeSpecNum.ClaimCode);
        if (data !== null) {
            setData(data);
            setCode(code??data[0])
        }
    }

    const createHandler=async (v) => {
        try {
            const obj ={name:v}
            const _ = await createCode(obj);
            if (_.status === 200) {

                handleActiveToast({message: _.data.title, description: _.data.reason});
                refreshCache(CacheType.customCode);
            } else if (_.status === 201 || (_.status === 202)) {
                handleActiveError({message: _.data.title, description: _.data.reason});
            } else {
                console.log(_)
                handleActiveToast({
                    description: "알 수 없는 에러.", message: "등록할 수 없습니다..", labelListener: () => {
                    }
                })
            }
        } catch (error) {
        } finally {
            //toDo 상세설명이나 정렬순서를 수정한 거라면 getList() 하지 않는게 사용자 경험에 도움이 됨
            getList();
        }
    }

    const updateHandler=async (e) => {
        try {
            const _ = await updateCustomCode(e);
            if (_.status === 200) {
                handleActiveToast({
                    description: "", message: "수정 되었습니다.", labelListener: () => {
                    }
                })

                refreshCache(CacheType.customCode);
            } else if (_.status === 201 || (_.status === 202)) {
                handleActiveError({message: _.data.title, description: _.data.reason});
            } else {
                console.log(_)
                handleActiveToast({
                    description: "알 수 없는 에러.", message: " 수정할 수 없습니다..", labelListener: () => {
                    }
                })
            }
        } catch (error) {
        } finally {
            //toDo 상세설명이나 정렬순서를 수정한 거라면 getList() 하지 않는게 사용자 경험에 도움이 됨
            getList();
        }
    }

    const deleteHandler =async (e) => {
        try {
            const _ = await deleteCustomCode(e);
            if (_.status === 200) {
                handleActiveToast({
                    description: "", message: "삭제 되었습니다.", labelListener: () => {
                    }
                })

                refreshCache(CacheType.customCode);
            } else if (_.status === 201 || (_.status === 202)) {
                handleActiveError({message: _.data.title, description: _.data.reason});
            } else {
                console.log(_)
                handleActiveToast({
                    description: "알 수 없는 에러.", message: " 삭제할 수 없습니다..", labelListener: () => {
                    }
                })
            }
        } catch (error) {
        } finally {
            getList();
        }
    }

    return (
        <div className={`common-container w-full h-container`}>
            <PageHeader header={"요청분류 코드관리"} indicator={"환경설정 > 코드관리 > 요청분류 코드관리"}/>
            <RecursiveListComponent
                setTarget={setCode}
                top={<CodeCreateInput creator={createHandler}  title={"요청 분류 코드를 생성하시려면 클릭하세요"} />}
                list={data? <RecursiveList data={data} setTarget={setCode} creator={createHandler} updater={updateHandler} deleter={deleteHandler}/> : null}       // data: 좌측 리스트 데이터 setCode : 리스트에서 클릭한 요소 넘기기
                info={data? <RecursiveInfo title={'코드명'} code={{code: code, fnc: setCode}} update={updateHandler}  /> : null} // code : list에서 클릭한 요소, update : 클릭한 요소의 수정 api
            />
        </div>
    );
}

export default ClaimCode;